module.exports = __webpack_public_path__ + "static/media/new_gold_star.a57fe153.svg";